import * as UserActions from '../actions/user.actions';

export interface UserState {
  impersonatedUserId: string | null;
}

const initialState: UserState = {
  impersonatedUserId: null
};

export function userReducer(
  state = initialState,
  action: UserActions.UserActions
): UserState {
  console.log('action', JSON.stringify(action));

  switch (action.type) {
    case UserActions.SET_IMPERSONATED_USER:
      return {
        ...state,
        impersonatedUserId: action.payload.userId
      };

    case UserActions.CLEAR_IMPERSONATED_USER:
      return {
        ...state,
        impersonatedUserId: null
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/user.reducer.ts